/**
 * Validation code metadata for display.
 * Unknown codes fall back to the backend message from the API response.
 *
 * Open items (not confirmed in API):
 * - functionalgroup vs functional_group
 * - wm-app connector validation code
 */

export const LOOKUP_REQUIRED_MESSAGE =
  "Needs a lookup — the correct ID must come from WaterMinds.";

/** @type {Record<string, { description: string, lookupRequired?: boolean }>} */
export const CONTEXT_IMPORT_VALIDATION_CODES = {
  NAME_TOO_LONG: {
    description: "node_name is longer than 40 characters.",
  },
  INVALID_NODE_NAME_CONVENTION: {
    description:
      "node_name uses characters other than letters, numbers and spaces.",
  },
  INVALID_SUBTYPE_FOR_TYPE: {
    description: "The subtype belongs to a different node type.",
  },
  UNKNOWN_NODE_TYPE: {
    description: "Node type is not recognized by the platform.",
  },
  CONTEXT_NODE_NOT_FOUND: {
    description: "The positive node_id isn't an existing context node.",
    lookupRequired: true,
  },
  SPARKPLUG_METRIC_NOT_FOUND: {
    description: "No Sparkplug metric has this ID.",
    lookupRequired: true,
  },
  WIMS_VARIABLE_NOT_FOUND: {
    description: "Referenced WIMS variable was not found.",
    lookupRequired: true,
  },
};

export function getValidationCodeDefinition(code) {
  if (code == null || String(code).trim() === "") {
    return null;
  }
  return CONTEXT_IMPORT_VALIDATION_CODES[String(code).trim()] ?? null;
}

export function getValidationCodeDescription(code, backendMessage = "") {
  const definition = getValidationCodeDefinition(code);
  if (definition?.description) {
    return definition.description;
  }
  const trimmed = String(backendMessage ?? "").trim();
  return trimmed || String(code ?? "");
}

export function isLookupRequiredCode(code) {
  return Boolean(getValidationCodeDefinition(code)?.lookupRequired);
}

export function formatCodeForDisplay(code) {
  return String(code ?? "").split("_").join("_\u200B");
}
